// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as EligibilityHelpers$OrcaPaymentPage from "../Utilities/EligibilityHelpers.bs.js";

function EligibilityNotice(props) {
  let __className = props.className;
  let __isEligibilityPending = props.isEligibilityPending;
  let eligibilityError = props.eligibilityError;
  let eligibilitySurchargeDetails = props.eligibilitySurchargeDetails;
  let __isEligibilityPending_value = __isEligibilityPending !== undefined ? __isEligibilityPending : false;
  let __className_value = __className !== undefined ? __className : "";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let themeObj = match.themeObj;
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let surchargeAmount = Core__Option.getOr(Core__Option.map(eligibilitySurchargeDetails, s => s.displayTotalSurchargeAmount.toString()), "");
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: __isEligibilityPending_value || Core__Option.isSome(eligibilityError) || Core__Option.isSome(eligibilitySurchargeDetails),
    children: JsxRuntime.jsx("div", {
      children: __isEligibilityPending_value ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("span", {
              children: localeString.paymentDetailsBeingCheckedText,
              className: "sr-only"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                className: "absolute inset-0 -translate-x-full animate-[shimmer_1.4s_ease_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent"
              }),
              "aria-hidden": true,
              className: "relative h-2.5 w-[72%] overflow-hidden rounded",
              style: {
                backgroundColor: themeObj.borderColor,
                opacity: "0.75"
              }
            })
          ],
          "aria-atomic": true,
          "aria-live": "polite",
          className: "w-full",
          role: "status"
        }) : (
          Core__Option.isSome(eligibilityError) ? JsxRuntime.jsx("div", {
              children: EligibilityHelpers$OrcaPaymentPage.getCardEligibilityErrorText(eligibilityError, localeString),
              "aria-atomic": true,
              "aria-live": "polite",
              className: "flex items-start text-xs",
              role: "alert",
              style: {
                color: themeObj.colorDangerText,
                lineHeight: "1.45"
              }
            }) : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("span", {
                  children: JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
                    name: "asterisk",
                    size: 8,
                    className: "text-red-600 mr-1 mt-[3px] shrink-0"
                  }),
                  "aria-hidden": true
                }),
                JsxRuntime.jsx("div", {
                  children: localeString.surchargeMsgAmountForCard(paymentMethodListValue.currency, surchargeAmount),
                  className: "text-left",
                  style: {
                    color: themeObj.colorTextSecondary,
                    lineHeight: "1.45"
                  }
                })
              ],
              "aria-atomic": true,
              "aria-live": "polite",
              className: "flex items-start text-xs",
              role: "status"
            })
        ),
      className: `w-full ` + __className_value
    })
  });
}

let make = EligibilityNotice;

export {
  make,
}
/* jotai Not a pure module */
